/* CUSTOM_STALESUPPRESS_BY_CLAUDE (AIOPS 4fba66ff3916, Ryan 2026-09-11)
   ─────────────────────────────────────────────────────────────────────────────
   Settings → Admin: Parked Inbox Mail — the JS half. Markup in
   snippets/rep-settings-parked-mail.liquid.

   ⛔ ITS OWN ASSET BECAUSE THE SECTION IS FULL — rep-quote-settings.liquid is ~253 KB of
   Shopify's 256 KB cap and this panel inline took it over. Same rule, and the same precedent,
   as rep-settings-agent-panels.js.

   ⛔ IT POSTS ONLY ITS OWN TWO FIELDS. /order-filing-config merges field by field and an ABSENT
   field keeps its prior value, so this Save cannot disturb the filing switches next door — which
   is what makes a second, independent panel safe rather than a race with "Save Filing Rules".
   ⚠️ An EMPTY box therefore has to send an empty ARRAY, not nothing: clearing the box is a real
   edit meaning "stop parking anything", and `undefined` would silently mean "leave it as it was".

   Loaded deferred from the section after custom-rep-portal.js (which defines
   window.RepPortal.API); runs on DOMContentLoaded. showMsg / hideMsg are the section's two
   helpers, copied because they are IIFE-local there. */
(function () {
  'use strict';

  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function hideMsg(el) {
    if (!el) return;
    el.className = 'rep-settings__message';
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  /** Commas, semicolons or newlines; blanks dropped. */
  function splitList(v) {
    return String(v == null ? '' : v).split(/[,\n;]+/)
      .map(function (x) { return x.trim(); })
      .filter(function (x) { return !!x; });
  }

  function initParkedMail() {
    if (!window.RepPortal || !window.RepPortal.API) return;
    var refs = document.getElementById('settings-parkedmail-refs');
    var from = document.getElementById('settings-parkedmail-from');
    var btn = document.getElementById('settings-parkedmail-btn');
    var msg = document.getElementById('settings-parkedmail-msg');
    var refresh = document.getElementById('settings-parkedmail-refresh');
    var list = document.getElementById('settings-parkedmail-list');
    if (!refs || !from || !btn) return;

    /* ⛔ NOTHING IS DEFAULTED IN THE MARKUP — the boxes start empty and are filled from the
       server, so a failed load can never look like "there is nothing parked" and then SAVE that
       emptiness over a real list. The Save button is disabled until the load lands. */
    btn.disabled = true;
    (function load() {
      window.RepPortal.API.get('/order-filing-config').then(function (cfg) {
        refs.value = ((cfg && cfg.staleSuppressRefs) || []).join(', ');
        from.value = ((cfg && cfg.staleSuppressFrom) || []).join(', ');
        btn.disabled = false;
      }).catch(function () {
        showMsg(msg, 'Could not load the parked lists - reload the page before saving, or you would save over them.', 'error');
      });
    })();

    btn.addEventListener('click', function () {
      hideMsg(msg);
      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = 'Saving...';
      var nRefs = splitList(refs.value);
      var nFrom = splitList(from.value);
      window.RepPortal.API.post('/order-filing-config', {
        staleSuppressRefs: nRefs,
        staleSuppressFrom: nFrom,
      }).then(function () {
        showMsg(msg, nRefs.length || nFrom.length
          ? 'Saved - ' + nRefs.length + ' order' + (nRefs.length === 1 ? '' : 's') + ' and '
            + nFrom.length + ' sender' + (nFrom.length === 1 ? '' : 's') + ' parked. Nobody is woken about their mail.'
          : 'Saved - nothing is parked. Every piece of order mail counts as work again.', 'success');
        loadParked();
      }).catch(function (e) {
        showMsg(msg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
      }).then(function () {
        btn.disabled = false;
        btn.textContent = orig;
      });
    });

    /* What the lists are actually catching, read off the same route the inbox queue reads — so
       the panel and that queue can never disagree about which message is parked. */
    function loadParked() {
      if (!list) return;
      list.innerHTML = '<p style="font-size:13px;color:var(--rq-text-secondary);margin:0;">Loading&hellip;</p>';
      window.RepPortal.API.get('/order-mail/unfiled?hours=0').then(function (d) {
        if (d && d.connected === false) {
          list.innerHTML = '<p style="font-size:13px;color:var(--rq-text-secondary);margin:0;">orders@ is not connected, so the inbox cannot be read.</p>';
          return;
        }
        var parked = ((d && d.unfiled) || []).filter(function (m) { return m.suppressed; });
        if (!parked.length) {
          /* ⚠️ "Nothing parked" is a real answer, not an empty state - and it is worded so it
             cannot be mistaken for a failed read, which is what the catch below reports. */
          list.innerHTML = '<p style="font-size:13px;color:var(--rq-text-secondary);margin:0;">Nothing in the inbox is parked right now.</p>';
          return;
        }
        var byRef = {};
        parked.forEach(function (m) { (byRef[m.ref] = byRef[m.ref] || []).push(m); });
        var html = '';
        Object.keys(byRef).sort().forEach(function (ref) {
          var msgs = byRef[ref];
          var why = msgs[0].suppressedBy === 'from'
            ? 'sender ' + esc(msgs[0].suppressedValue)
            : msgs[0].suppressedBy === 'message'   // CUSTOM_INBOXKEEP_BY_CLAUDE - a single kept message
              ? 'a single-message keep (' + esc(msgs[0].suppressedValue) + ')'
              : 'order ' + esc(msgs[0].suppressedValue || ref);
          html += '<div style="border:1px dashed var(--rq-border,#1e2a42);border-radius:8px;padding:8px 12px;margin:0 0 6px;">'
            + '<div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;">'
            + '<strong style="font-size:13px;">' + esc(ref) + '</strong>'
            + '<span style="font-size:12px;color:var(--rq-text-secondary);">' + msgs.length + ' message'
            + (msgs.length === 1 ? '' : 's') + ' &mdash; parked by ' + why + '</span></div>'
            + '<ul style="margin:4px 0 0;padding-left:18px;font-size:12px;color:var(--rq-text-secondary);">'
            + msgs.map(function (m) { return '<li>' + esc(m.subject) + '</li>'; }).join('')
            + '</ul></div>';
        });
        list.innerHTML = html;
      }).catch(function (e) {
        list.innerHTML = '<p style="font-size:13px;color:var(--rq-error,#e08a80);margin:0;">Could not read the inbox: '
          + esc(e && e.message ? e.message : 'unknown error') + '</p>';
      });
    }
    if (refresh) refresh.addEventListener('click', loadParked);
    loadParked();
    initKeepMail();
  }

  /* CUSTOM_INBOXKEEP_BY_CLAUDE (AIOPS 54ee9977a350, Ryan 2026-09-26) - ONE message kept on purpose.
     The kept list loads with the page (one KV list, cheap). The leftovers are the 8:21 AM sweep's own
     DRY RUN - the same list that wakes the desk - so they load on a click, never on page open: that
     read walks the inbox and every deal it names.
     ⛔ Keyed on the internetMessageId, which survives a folder move; the Graph id does not. */
  function initKeepMail() {
    var keptBox = document.getElementById('settings-keepmail-kept');
    var loadBtn = document.getElementById('settings-keepmail-load');
    var leftBox = document.getElementById('settings-keepmail-leftovers');
    var reason = document.getElementById('settings-keepmail-reason');
    var msg = document.getElementById('settings-keepmail-msg');
    if (!keptBox || !loadBtn || !leftBox) return;
    var muted = 'font-size:13px;color:var(--rq-text-secondary);margin:0;';
    var rowCss = 'border:1px dashed var(--rq-border,#1e2a42);border-radius:8px;padding:8px 12px;margin:0 0 6px;display:flex;align-items:center;gap:10px;flex-wrap:wrap;';
    var btnCss = 'margin-left:auto;padding:4px 12px;font-size:12px;';

    function rowHtml(r, label, act) {
      return '<div style="' + rowCss + '">'
        + '<div style="flex:1;min-width:200px;"><div style="font-size:13px;font-weight:600;">' + esc(r.subject || '(no subject)') + '</div>'
        + '<div style="font-size:12px;color:var(--rq-text-secondary);">' + esc(r.from || '') + (label ? ' &middot; ' + label : '') + '</div></div>'
        + '<button type="button" class="rep-settings__submit" style="' + btnCss + '" data-keep-act="' + act + '"'
        + ' data-imid="' + esc(r.internetMessageId || r.imid || '') + '" data-subject="' + esc(r.subject || '') + '" data-from="' + esc(r.from || '') + '">'
        + (act === 'keep' ? 'Keep in inbox' : 'Unkeep') + '</button></div>';
    }

    function loadKept() {
      keptBox.innerHTML = '<p style="' + muted + '">Loading&hellip;</p>';
      return window.RepPortal.API.get('/admin/order-mail/keep').then(function (d) {
        var kept = (d && d.kept) || [];
        if (!kept.length) { keptBox.innerHTML = '<p style="' + muted + '">No single messages are kept right now.</p>'; return; }
        keptBox.innerHTML = kept.map(function (k) {
          var label = 'kept' + (k.by ? ' by ' + esc(k.by) : '') + (k.at ? ' ' + esc(String(k.at).slice(0, 10)) : '')
            + (k.reason ? ' &mdash; ' + esc(k.reason) : '');
          return rowHtml(k, label, 'unkeep');
        }).join('');
      }).catch(function (e) {
        keptBox.innerHTML = '<p style="font-size:13px;color:var(--rq-error,#e08a80);margin:0;">Could not load the kept messages: '
          + esc(e && e.message ? e.message : 'unknown error') + '</p>';
      });
    }

    function loadLeftovers() {
      loadBtn.disabled = true;
      leftBox.innerHTML = '<p style="' + muted + '">Reading the inbox&hellip; this takes a few seconds.</p>';
      window.RepPortal.API.get('/admin/order-mail/inbox-sweep').then(function (d) {
        var rows = ((d && d.rows) || []).filter(function (r) { return r.internetMessageId; });
        if (reason) reason.style.display = rows.length ? '' : 'none';
        if (!rows.length) {
          leftBox.innerHTML = '<p style="' + muted + '">Nothing in the inbox would wake the desk tomorrow morning.</p>';
          return;
        }
        leftBox.innerHTML = '<p style="' + muted + 'margin-bottom:8px;">These ' + rows.length
          + ' would wake the desk at tomorrow&rsquo;s 8:21 AM sweep.</p>'
          + rows.map(function (r) {
            return rowHtml(r, (r.ref ? esc(r.ref) + ' &middot; ' : 'no order &middot; ') + esc(String(r.ageHours)) + 'h old', 'keep');
          }).join('');
      }).catch(function (e) {
        leftBox.innerHTML = '<p style="font-size:13px;color:var(--rq-error,#e08a80);margin:0;">Could not read the inbox: '
          + esc(e && e.message ? e.message : 'unknown error') + '</p>';
      }).then(function () { loadBtn.disabled = false; });
    }

    /* ONE delegated listener on the panel, wired once. */
    var panel = document.getElementById('settings-admin-parkedmail');
    if (panel && !panel._keepWired) {
      panel._keepWired = true;
      panel.addEventListener('click', function (ev) {
        var b = ev.target && ev.target.closest ? ev.target.closest('[data-keep-act]') : null;
        if (!b) return;
        var act = b.getAttribute('data-keep-act');
        var body = { action: act, internetMessageId: b.getAttribute('data-imid') };
        if (act === 'keep') {
          body.subject = b.getAttribute('data-subject');
          body.from = b.getAttribute('data-from');
          if (reason && reason.value.trim()) body.reason = reason.value.trim();
        }
        hideMsg(msg);
        b.disabled = true;
        window.RepPortal.API.post('/admin/order-mail/keep', body).then(function () {
          showMsg(msg, act === 'keep' ? 'Kept. The desk will not be woken about that message.' : 'Unkept. That message counts as work again.', 'success');
          if (act === 'keep') { var row = b.parentNode; if (row && row.parentNode) row.parentNode.removeChild(row); }
          loadKept();
        }).catch(function (e) {
          b.disabled = false;
          showMsg(msg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
        });
      });
    }
    loadBtn.addEventListener('click', loadLeftovers);
    loadKept();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParkedMail);
  } else {
    initParkedMail();
  }
})();
